var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#393939",
    strokeWidth: 1.38667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78372 13.0664H8.12227V6.86745H9.78372V13.0664ZM8.02487 5.26328C8.02487 5.01502 8.10699 4.81068 8.27122 4.65026C8.43928 4.48984 8.66654 4.40964 8.95299 4.40964C9.23563 4.40964 9.46098 4.48984 9.62904 4.65026C9.79709 4.81068 9.88112 5.01502 9.88112 5.26328C9.88112 5.51537 9.79518 5.72162 9.62331 5.88203C9.45525 6.04245 9.23181 6.12266 8.95299 6.12266C8.67418 6.12266 8.44883 6.04245 8.27695 5.88203C8.1089 5.72162 8.02487 5.51537 8.02487 5.26328Z",
    fill: "#393939"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.004dbb9332ecaa42fcd66024df21d394.svg";
export { ForwardRef as ReactComponent };